<template>
  <div class="grid-content">
    <div class="grid-banner-image" :style="{ backgroundImage: `url(${gridBannerImageSrc})` }"></div>
    <div class="grid-overlay-image">
      <h1 class="grid-banner-title">{{ gridBannerImageTitle }}</h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import GridPageMixin from '@/mixins/grid-page-mixin'
import { GridPageStore } from '@/store/visual-identity-page/grid-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class GridSection extends Mixins(GridPageMixin) {
  gridPageStore: PageStoreContract = getModule(GridPageStore, this.$store)

  get gridBannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get gridBannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getGridPage(): Promise<void> {
    await this.gridPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.gridPageStore.isLoading) {
      await this.getGridPage()
    }
  }
}
</script>

<style lang="scss">
.grid-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;

  width: 100%;
  max-height: 28rem;
}

.grid-banner-image {
  position: relative;
  width: 100%;
  height: 451px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.grid-overlay-image {
  position: absolute;
  bottom: 9rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.grid-banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  letter-spacing: -0.01em;
  text-align: left;
}

@media (min-width: 1726px) {
  .grid-content {
    width: 100%;
  }
}
</style>
